import React, { useState, useEffect } from 'react';
import { Menu, X, Smartphone } from 'lucide-react';
import { ReactComponent as Logo } from '../assets/logo.svg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { href: '#funcionalidades', label: 'O que você ganha' },
    { href: '#como-funciona', label: 'Simples assim' },
    { href: '#gratuito', label: 'Use sem pagar nada' },
    { href: '#depoimentos', label: 'Quem já usa' },
    { href: '#faq', label: 'Tire suas dúvidas' },
  ];

  const navItemsMobile = [
    { href: '#home', label: 'Início' },
    { href: '#funcionalidades', label: 'O que você ganha' },
    { href: '#como-funciona', label: 'Simples assim' },
    { href: '#gratuito', label: 'Use sem pagar nada' },
    { href: '#depoimentos', label: 'Quem já usa' },
    { href: '#faq', label: 'Tire suas dúvidas' },
    { href: '#privacidade', label: 'Privacidade' },
    { href: '#termos-uso', label: 'Termos de Uso' },
    { href: '#seguranca', label: 'Segurança' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-lg py-2'
          : 'bg-white/95 backdrop-blur-sm py-3'
      }`}
    >
      <div className='container mx-auto px-4'>
        <div className='flex flex-col lg:flex-row items-center justify-between gap-0 lg:gap-0'>
          {/* Logo */}
          <a
            href='#home'
            className={`flex items-center space-x-2 transition-all duration-300 ${
              isScrolled ? 'scale-90' : 'scale-100'
            }`}
          >
            <Logo className='w-10 h-10' />
            <span
              className={`font-bold transition-all duration-300 ${
                isScrolled ? 'text-xl' : 'text-2xl'
              }`}
            >
              <span className='text-blue-500'>Fin</span>
              <span className='text-emerald-500'>Ziin</span>
            </span>
          </a>

          {/* Desktop Navigation Grid */}
          <nav className='hidden lg:grid gap-2 lg:gap-4 mt-2 lg:mt-0 w-full max-w-[600px] grid-cols-5 text-center auto-rows-auto'>
            {navItems.map((item, index) => (
              <a
                key={item.href}
                href={item.href}
                className='relative text-gray-700 font-medium transition-colors duration-300 group break-words px-2 py-1 whitespace-normal'
              >
                {item.label}
                <span className='absolute left-0 -bottom-1 w-0 h-0.5 bg-[#035552] transition-all duration-300 group-hover:w-full'></span>
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className='hidden lg:flex items-center space-x-4 mt-2 lg:mt-0'>
            <a
              href='https://play.google.com/store/apps/details?id=br.android.finziin'
              target='_blank'
              rel='noopener noreferrer'
              className='btn-primary flex items-center space-x-2'
            >
              <Smartphone size={18} />
              <span>Quero meu app grátis</span>
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            className='lg:hidden p-2 mt-0'
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className='lg:hidden mt-0 pb-0 border-t pt-4'>
            <div className='flex flex-col space-y-4'>
              {navItemsMobile.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className='text-gray-700 hover:text-[#035552] font-medium transition-colors duration-300'
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <a
                href='https://play.google.com/store/apps/details?id=br.android.finziin'
                target='_blank'
                rel='noopener noreferrer'
                className='btn-primary flex items-center justify-center space-x-2 mt-4'
              >
                <Smartphone size={18} />
                <span>Quero meu app grátis</span>
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
